export const orgStatErrors = [
    {
        code: "SRS_VALIDATION-35",
        message: "Please select a valid date range",
    },
];
